import { CwtMenuItem } from "@cawita/core-front/navigation";

export const LAYOUT_MENU: CwtMenuItem[] = [{
    type: 'link',
    label: 'navbar.dashboard',
    icon: 'dashboard',
    link: ['/dashboard']
}, {
    type: 'link',
    label: 'navbar.admin',
    link: ['/user'],
    icon: 'safety-certificate',
    accessibility: {
        permissions: 'manageUsers',
    }
}, {
    type: 'link',
    label: 'navbar.role',
    link: ['/role'],
    icon: 'setting',
    accessibility: {
        permissions: 'manageRoles',
    }
}];
